import HttpService from 'ui-home/src/misc/HttpService/HttpService';
import checkEnvironment from 'ui-common/src/lib/checkEnvironment';
import { Cookies } from 'react-cookie';

export const SAVE_PROFILE_IMAGE = 'SAVE_PROFILE_IMAGE';
export const CLEAR_PROFILE_IMAGE = 'CLEAR_PROFILE_IMAGE';
export const FETCH_PROFILE_MENU = 'FETCH_PROFILE_MENU';
export const FETCH_LANGUAGE_LIST = 'FETCH_LANGUAGE_LIST';
export const CLOSE_LANGUAGE_MODAL = 'CLOSE_LANGUAGE_MODAL';
export const FETCH_GET_HELP = 'FETCH_GET_HELP';
export const FETCH_GET_ISPM_INTRO = 'FETCH_GET_ISPM_INTRO';

const cookies = new Cookies();

const InitializeProfileMenu = () => (dispatch) => {
  const response = HttpService.get('/ECM/navigation/userProfileMenu', { 'X-NOERRORMODAL': true });

  response.then((res) => {
    dispatch({
      type: FETCH_PROFILE_MENU,
      data: res,
    });
  });
};

const SaveProfileImage = (url) => (dispatch) => {
  dispatch({
    type: SAVE_PROFILE_IMAGE,
    url,
  });
};

const ClearProfileImage = () => (dispatch) => {
  dispatch({
    type: CLEAR_PROFILE_IMAGE,
  });
};

const InitializeMuteEmail = (isMuted) => () => {
  const { ECM_URL } = checkEnvironment();

  const response = HttpService.post('/ECM/navigation/enableMuteEmail', {
    muteEmail: Number(isMuted),
  });

  response.then(() => {
    window.location.reload();
  });
};

const InitializeLanguageList = () => (dispatch) => {
  const { ECM_URL } = checkEnvironment();
  const response = HttpService.get('/ECM/navigation/configuredLanguages');

  response.then((res) => {
    dispatch({
      type: FETCH_LANGUAGE_LIST,
      data: res,
    });
  });
};

const InitializeUpdateLanguage = (selectedLanguage) => () => {
  return HttpService.get(`/ECM/users/updateLanguage?lang=${selectedLanguage}`).catch((e) => {
    if (e.name === 'SyntaxError') {
      // Swallow as expected. HttpService always JSON.parse's, but this endpoint doesn't return JSON.
      return;
    }
    throw e;
  });
};

const CloseLanguageModal = () => (dispatch) => {
  dispatch({
    type: CLOSE_LANGUAGE_MODAL,
  });
};

const InitializeGetHelp = () => (dispatch) => {
  const response = HttpService.get('/ECM/navigation/help', { 'X-NOERRORMODAL': true });

  response.then((res) => {
    dispatch({
      type: FETCH_GET_HELP,
      data: res,
    });
  });
};

const InitializeGetIspmIntro = () => (dispatch) => {
  const response = HttpService.get(
    `${window.location.origin}/ECMv6/api/ispm/v1/identity/${cookies.get(
      'userKey'
    )}/view/ispm_intro`,
    { 'X-NOERRORMODAL': true }
  );

  response.then((res) => {
    dispatch({
      type: FETCH_GET_ISPM_INTRO,
      data: res?.data?.preference?.viewed,
    });
  });
};

export {
  InitializeProfileMenu,
  InitializeMuteEmail,
  InitializeLanguageList,
  InitializeUpdateLanguage,
  CloseLanguageModal,
  SaveProfileImage,
  ClearProfileImage,
  InitializeGetHelp,
  InitializeGetIspmIntro,
};
